import React from "react";
import { useField } from "formik";
import styled from "styled-components";

type Props = {
  label: string;
  name: string;
  placeholder?: string;
  rows?: number;
  cols?: number;
};

// Styled Components
const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Label = styled.label`
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  line-height: 20.16px;
  font-family: "Sora", sans-serif;
`;

const TextArea = styled.textarea<{ hasError: boolean }>`
  border: ${(props) => (props.hasError ? "2px solid #FF5E65" : "none")};
  border-radius: 10px;
  background: #f5f5f5;
  padding: 12px;
  outline: none;
  resize: none; /* Prevents resizing */
  font-family: "Sora", sans-serif;
`;

const ErrorText = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #d91f27;
  font-family: "Sora", sans-serif;
`;

const TextAreaField: React.FC<Props> = ({
  label,
  rows = 5,
  cols = 50,
  ...props
}) => {
  const [field, meta] = useField(props);

  return (
    <FieldWrapper>
      <Label htmlFor={props.name}>{label}</Label>
      <TextArea
        {...field}
        {...props}
        id={props.name}
        rows={rows}
        cols={cols}
        hasError={meta.touched && !!meta.error}
      />
      {meta.touched && meta.error ? <ErrorText>{meta.error}</ErrorText> : null}
    </FieldWrapper>
  );
};

export default TextAreaField;
